import React from 'react';
import clsx from 'clsx';
import { is, has } from '../../../services';
import { Columns, ColumnsItem } from '../../columns';
import { Text } from '../../text';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Info Block Content
 * @param children {React.ReactNode} Children content
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param size {number} Sizes available => 1 - 12
 */
const InfoBlockContent = ({ className, size, children, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('info-block-content', has('text-centered'), className));
    return (React.createElement("div", { className: classes, ...others },
        React.createElement(Columns, { className: is('vcentered'), centered: true },
            React.createElement(ColumnsItem, { size: size || 8 },
                React.createElement("div", { style: { marginTop: '1rem', marginBottom: '2rem' } }, children && typeof children.valueOf() === 'string' ? React.createElement(Text, null, String(children)) : children)))));
};
export default InfoBlockContent;
//# sourceMappingURL=InfoBlockContent.js.map